export default function highlightReducer(highlighted, { key, options }) {
	let newHighlighted = -1;

	if (['ArrowDown', 'ArrowUp'].includes(key)) {
		const max = options.length - 1;
		newHighlighted =
			key === 'ArrowDown' ? highlighted + 1 : highlighted - 1;

		if (newHighlighted < 0) {
			newHighlighted = max;
		} else if (newHighlighted > max) {
			newHighlighted = 0;
		}
	}

	return newHighlighted;
}
